import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { Member } from '@app/models/member';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class MemberService {
  asyncResult: any;
  ownBaseInfoSubject = new BehaviorSubject(null);
  _ownbasicinfo: Subscription;
  timestamp = new BehaviorSubject(null);
  newmemberdata = new BehaviorSubject(null);
  baseinfo: string;

  handleError<T>(arg0: any): any {
    throw new Error('Method not implemented.');
  }

  constructor(private http: HttpClient) {
  }

  getMemberById(id: number) {
    return this.http.get<any>(environment.apiUrl + 'Member/GetMemberByIdAsync/' + id);
  }

  getMemberById2(id: number) {
    return this.http.get<any>(environment.apiUrl + 'Member/GetMemberByIdAsync/' + id);
  }

  getCurrentActiveMembers(id: number) {
    return this.http.get<any>(environment.apiUrl + 'Member/GetCurrentActiveMembers/' + id);
  }

  getSignsBySignType(id: number) {
    return this.http.get<any>(environment.apiUrl + 'Sign/GetSigns/' + id);
  }

  addMember(member: any): Observable<any> {
    const httpOptions: { headers; observe; } = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      observe: 'response'
    };

    return this.http.post<any>(environment.apiUrl + 'Member/CreateNewMember', JSON.stringify(member), httpOptions);
  }

  async getClaims() {
    const response = await this.getOwnBaseInfoAsync();
    return response;
  }

  errorHandler(error) {
    alert('FELMEDDELANDE:' + JSON.stringify(error));
  }

  updateMemberWithoutAccess(member: Member) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.put<any>(environment.apiUrl + 'Member/UpdateMemberWithoutAccess', JSON.stringify(member), httpOptions);
  }

  updateMember(member: Member) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.put<any>(environment.apiUrl + 'Member/UpdateMember', JSON.stringify(member), httpOptions);
  }

  searchMember(member: Member) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Member/SearchMembersAsync', JSON.stringify(member), httpOptions);
  }

  searchMemberPhotosByInstitutionId(searchdata: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Member/SearchMembersAsync', JSON.stringify(searchdata), httpOptions);
  }

  getMembersByBirthDateAsync(date): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'Member/GetMembersByBirthDateAsync/' + date);
  }

  getOwnBaseInfoAsync(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'Member/GetOwnBaseInfoAsync');
  }

  GetMemberImageThumbnail(memberid: number): Observable<Blob> {
    return this.http.get(environment.apiUrl + 'File/GetMemberImageThumbnail/' + memberid, { responseType: 'blob' });
  }

  setBaseInfo(baseinfo: string) {
    
    localStorage.setItem('claims', baseinfo);
    this.ownBaseInfoSubject.next(baseinfo);
  }

  getBaseInfo() {
    return JSON.parse(localStorage.getItem('claims'));
  }

  getMemberPrimaryInstitution(memberid: number): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'Member/GetMemberPrimaryInstitution/' + memberid);
  }

  getAllDistricts(subset: number): Observable<any> {
    // subset: 0 - all, 1 - brothers, 2 - rebecks
    return this.http.get<any>(environment.apiUrl + 'Institution/GetAllDistrictsAsync/' + subset);
  }

  getSignTypes(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'Sign/GetSignTypes');
  }

  getSigns(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'Sign/GetSigns');
  }

  updateMemberMembership(memberdata: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Membership/UpdateMemberMembership', JSON.stringify(memberdata), httpOptions);
  }

  getSOFTSubscribers() {
    return this.http.get<any>(environment.apiUrl + 'Report/GetSoftSubscribers');
  }

  GetBirthdays(birthdaydata: any) {
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(environment.apiUrl + 'Report/GetBirthdays/' + birthdaydata.institutionId + '/' + birthdaydata.year);
  }

  GetSmallMatrix(smallMatrixData: any) {
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(environment.apiUrl + 'Report/GetSmallMatrix/', smallMatrixData);
  }

  SearchMemberFromInstitutionByNameOrId(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(environment.apiUrl + 'Member/SearchMemberFromInstitutionByNameOrId', JSON.stringify(data), httpOptions);
  }

  ChangePrimaryInstitution(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Member/ChangePrimaryInstitution', JSON.stringify(data), httpOptions);
  }

  GetSignReport(signdata: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Report/GetSignReport', JSON.stringify(signdata), httpOptions);
  }

  GetOfficeReport(officedata: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Report/GetOfficeReport', JSON.stringify(officedata), httpOptions);
  }

  GetMemberInfoFromMemberIds(input: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Member/GetMemberInfoFromMemberIds', JSON.stringify(input), httpOptions);
  }

  GetMemberInfoFromInstitutionIds(input: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Member/GetMemberInfoFromInstitutionIds', JSON.stringify(input), httpOptions);
  }

  SearchMemberForOfficesAndSigns(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(environment.apiUrl + 'Member/SearchMemberForOfficesAndSigns', JSON.stringify(data), httpOptions);
  }

  handleMemberGDPR(memberId: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const member = { Id: memberId, FamilyName: 'test', GivenName: 'test' };
    return this.http.put<any>(environment.apiUrl + 'Member/HandleMemberGDPR', JSON.stringify(member), httpOptions);
  }

  CreateMemberLabelMatrixReportForDownload(params: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Institution/CreateMemberLabelMatrixReportForDownload', JSON.stringify(params), httpOptions);
   // return this.http.post<any>(environment.apiUrl + 'Institution/GetInstitutionLabelMatrix', JSON.stringify(params), httpOptions);
  }
}
